export const Name = 'declarationComponent';
